import { ProgressSliderApi } from "../../../../shared/progress-slider/view";
import { useEffect, useState } from "react";
import LocalStorage, { PLAYER_VOLUME_KEY, PLAYER_VOLUME_MUTED_KEY } from "../../../../../utils/local-storage";
import { isMobileDevice } from "../../../../../utils/device-utils";

type UseVolumeSliderProps = {
    volumeSliderRef: React.RefObject<ProgressSliderApi>;
    volumeIconRef: React.RefObject<HTMLDivElement>;
    audioRef: React.RefObject<HTMLAudioElement>;
}

const UseVolumeSlider = ({ volumeSliderRef, volumeIconRef, audioRef }: UseVolumeSliderProps) => {
    const [muted, setMuted] = useState(false);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        if (loaded) return;
        setLoaded(true);
        loadVolumeStorage();
    }, [audioRef.current, volumeSliderRef.current]);

    const loadVolumeStorage = () => {
        if (audioRef.current && volumeSliderRef.current) {
            let loadVolume = LocalStorage.getItem<number>(PLAYER_VOLUME_KEY) ?? 100;
            if (isMobileDevice()) {
                loadVolume = 100;
            }
            audioRef.current.volume = loadVolume / 100;
            volumeSliderRef.current.setProgress(loadVolume);

        }
    }

    const handleVolumeChange = (volume: number) => {
        if (!audioRef.current) return;
        if (isMobileDevice()) {
            volume = 100;
        }

        audioRef.current.volume = volume / 100;
        LocalStorage.setItem(PLAYER_VOLUME_KEY, volume);

    }

    const handleMute = (isMuted: boolean) => {
        setMuted(isMuted);
        LocalStorage.setItem(PLAYER_VOLUME_MUTED_KEY, isMuted);

        if (!isMuted) {
            loadVolumeStorage();
        } else {
            if (audioRef.current) {
                audioRef.current.volume = 0;
                volumeSliderRef.current?.setProgress(0);
            }
        }

        return isMuted;
    }

    const toggleMute = () => {
        handleMute(!muted);
    }


    return { handleVolumeChange, toggleMute }
}

export default UseVolumeSlider;
